<template>
  <div>
    <div v-if="params.value !== '(Select All)'" class="d-flex">
      <span v-html="html" class="mr-1"></span>
      {{ options.find(item => item.value === status)?.label }}
    </div>
    <div v-else>(Select All)</div>
  </div>
</template>

<script>
import { Plane } from 'lucide-vue';
import { lucideHtml } from '@/core/common/helpers/lucide-html';

export default {
  data() {
    return {
      status: null,
      html: null,
      options: [
        {
          label: 'Nur SKR Inlandsflüge',
          value: 'NurSkr',
        },
        {
          label: 'Nur DMC Inlandsflüge',
          value: 'NurDmc',
        },
        {
          label: 'Gemischte Inlandsflüge',
          value: 'Gemischt',
        },
        {
          label: 'Kein Inlandsflug',
          value: 'KeinInlandsflug',
        },
      ],
    };
  },
  mounted() {
    if (this.params && this.params.value) {
      this.status = this.params.value;
      if (this.status === 'NurSkr') {
        this.html = lucideHtml(Plane, { class: 'text-danger' });
      } else if (this.status === 'NurDmc') {
        this.html = lucideHtml(Plane, { style: 'color: #000' });
      } else if (this.status === 'Gemischt') {
        this.html = lucideHtml(Plane, { style: 'color: #A6A6A8' });
      } else if (this.status === 'KeinInlandsflug') {
        this.html = '';
      }
    }
  },
  methods: {},
};
</script>
